
import $ from 'jquery';
import queryString from 'query-string';
import Loader from './Loader';

export default class AjaxFilter {
    constructor({ formSelector = null, searchFormName = null, callback = function () { }, valueInputSelector = null, sortInputSelector = 'select', resetInputSelector = '.filter-reset-button', paginationInputSelector = '.pagination li a', disableSubmitButtonIfVisible = false}) {
        this.formSelector = formSelector;
        this.searchFormName = searchFormName+'[search_query]';
        this.callback = callback;
        this.loader = new Loader();

        this.valueInputSelector = valueInputSelector;
        this.sortInputSelector = sortInputSelector;
        this.resetInputSelector = resetInputSelector;
        this.paginationInputSelector = paginationInputSelector;

        this.disableSubmitButtonIfVisible = disableSubmitButtonIfVisible;

        this.initFilter();
    }

    initFilter() {
        this.$formFilter = $(this.formSelector);
        this.submitButton = document.querySelector(this.formSelector + ' *[type="submit"]');

        let url = location.protocol + '//' + location.host + location.pathname;

        this.$formFilter.on('change', this.valueInputSelector, e => {
            e.preventDefault();

            if (this.disableSubmitButtonIfVisible && this.submitButton.checkVisibility()) {
                return;
            }

            this.$formFilter.submit();
        });

        this.$formFilter.on('change', this.sortInputSelector, e => {
            e.preventDefault();

            if (this.disableSubmitButtonIfVisible && this.submitButton.checkVisibility()) {
                return;
            }

            this.$formFilter.submit();
        });

        this.$formFilter.on('submit', e => {
            e.preventDefault();

            if (undefined != this.$formFilter.attr('action')) {
                url = this.$formFilter.attr('action');
            }

            this.sendRequest(this.$formFilter.attr('method'), url, this.$formFilter.serializeArray(), 'submit')
        });

        $(this.paginationInputSelector).on('click', e => {
            e.preventDefault();

            this.sendRequest('GET', $(e.target).attr('href'), {}, 'pagination');
        });

        $(this.resetInputSelector).on('click', e => {
            this.sendRequest('GET', url, {}, 'reset')
        });
    }

    sendRequest(method, url, data = [], type) {
        this.loader.show();

        const parameters = queryString.parse(location.search, {arrayFormat: 'index', decode: true});
        if (undefined != parameters[this.searchFormName]) {
            data.push({
                name: this.searchFormName,
                value: parameters[this.searchFormName]
            });
        }

        var xhr = new XMLHttpRequest();

        $.ajax({
            method: method,
            url: url,
            data: data,
            xhr: function() {
                return xhr;
            },
            success: function () {
                history.replaceState({}, '', xhr.responseURL);
            }
        }).done((content, textStatus, jqXHR) => {
            this.callback(content, type);

            this.loader.hide();
            this.initFilter();
        }).fail(xhr => {
            console.error('An error occured', xhr);
        });
    }
}
